<app-generic-table
  [tableConfig]="tableConfig" (tableEvent)="getCampaigns($event)"
></app-generic-table>